import {observer} from "mobx-react";
import React from "react";
import FontBody4 from "../../../components/fonts/font-body4/font-body4";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import {FormField} from "../../../components/form-field/form-field";
import {Input} from "../../../components/inputs/input/input";
import {IOption, SelectDropdownGrouped} from "../../../components/inputs/select-dropdown-grouped/select-dropdown-grouped";
import {SelectDropdown} from "../../../components/inputs/select-dropdown/select-dropdown";
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import {IValidationGroup} from "../../../hooks/validation-group/validation-group-hook";
import CreateRmaSettingsStore from "../stores/create-rma-settings-store";
import RequestProductStore from "../stores/request-product-store";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";

interface IProps{
	store:RequestProductStore;
	vGroup:IValidationGroup;
    createRmaSettingsStore: CreateRmaSettingsStore;
}
const GodModeItemDrawerFields:React.FC<IProps> = observer(({store, vGroup, createRmaSettingsStore})=>{
    
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
	const getSelectedResolution = () => {
		for (let i in createRmaSettingsStore.getResolutionsListOptions()) {
			const resolution = createRmaSettingsStore.getResolutionsListOptions()[i].options.find((resolution: IOption) => resolution.value === store.resolutionId);
			if (resolution) {
				return resolution;
			}
		}
	}

	return (
		<ListLayout>
			<FormField label={<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RESOLUTION', pageScope)}</FontBody2>} required={true}>
				<SelectDropdownGrouped
					options={createRmaSettingsStore.getResolutionsListOptions()}
					value={getSelectedResolution()}
					onChange={(v) => store.setResolution(v?.value as number)}
					required
                    isSearchable={true}
					validationGroup={vGroup}
                    target={null}
					placeholder={getTranslation('SELECT_PLACEHOLDER', pageScope)}
				/>
			</FormField>
			<FormField label={<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RETURN_METHOD', pageScope)}</FontBody2>} required={true}>
				<SelectDropdown
					options={createRmaSettingsStore.getReturnMethodsListOptions()}
					value={createRmaSettingsStore.getReturnMethodsListOptions().find( i => i.value === store.returnMethodId)}
					onChange={(v) => store.setReturnMethod(v?.value as number)}
					required
					isSearchable={true}
					validationGroup={vGroup}
                    target={null}
					placeholder={getTranslation('SELECT_PLACEHOLDER', pageScope)}
				/>
			</FormField>
            <span>
				<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RESTOCKING_FEE_PER_ITEM', pageScope)}</FontBody2>
				<Input temp required validationGroup={vGroup} adornment={store.paymentCurrencySymbol} value={store.restockingFee} min={0} onChange={v => store.setRestockingFee(v)} type={'number'}/>
			</span>
            <FormField
                label={<FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('ADJUSTMENTS_PER_ITEM', pageScope)}</FontBody2>}
                instructions={<FontBody4 color={FONT_COLOR.NEUTRAL3}>{getTranslation('ADJUSTMENTS_PER_ITEM_SUBTITLE', pageScope)}</FontBody4>}>
				    <Input temp required validationGroup={vGroup} adornment={store.paymentCurrencySymbol} value={store.adjustments} onChange={v => store.setAdjustment(v)} type={'number'}/>
            </FormField>
		</ListLayout>
	)
});

export default GodModeItemDrawerFields;